/*
 * Module for the security groups page
 */
rs.module("content/security/administration/groups",

    [
        "controls/data/grid",
    ],

    function (gridModule) {

        // initialize the module
        function initialize(jsSelectors, ajaxUrls, groupsGrid, membersGridLrsApi) {

            var _executeSelectionChanged;

            // js selectors
            var addMembersButton = $.js(jsSelectors.addMembersButton);
            var loadingTemplate = $.js(jsSelectors.loadingTemplate);
            var groupMembersHolder = $.js(jsSelectors.groupMembersHolder);

            // When selected group is changed, reload the members grid to match
            groupsGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    // refresh the members grid, values[0] is the selected group
                    refreshMembers(values[0]);
                }

                _executeSelectionChanged = true;
            });

            // when "Add" is clicked, open New Group popup
            $.js(jsSelectors.addGroupButton).click(function () {

                // remove existing validations and values
                _resetForm();

                // show the popup
                $.js(jsSelectors.newGroupModal).modal("show");
                $.js(jsSelectors.newGroupModal).js(jsSelectors.groupName).focus();
            });

            // refresh the group members grid to reflect the selected Group
            function refreshMembers(selectedGroup) {
                groupMembersHolder.hide();
                loadingTemplate.show();

                gridModule.update(
                    ajaxUrls.getGroupMembers,
                    { groupName: selectedGroup },
                    membersGridLrsApi.agGridApi,
                    function done(gridUpdate) {
                        loadingTemplate.hide();
                        groupMembersHolder.show();

                        // Make sure the add members link reflects the currently selected Group
                        addMembersButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            }

            // reset the form fields and validations
            function _resetForm() {
                var form = $.js(jsSelectors.newGroupModal).js(jsSelectors.newGroupForm);

                // clear groupName's value and any errors
                form.js(jsSelectors.groupName).val(null);
                form.js(jsSelectors.groupName).clearErrors();

                // Reset validation
                $.validator.resetValidation(form);
            }

        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);